<template>
  <div id="checkOrder">
    <div class="title">
      <p class="name">确认订单<span class="back" @click="back()" v-if="isApp !==2">返回<i class="backIcon">></i></span></p>
    </div>
    <div class="MainBody" :style="{paddingBottom:tabHeight>0?125+tabHeight+'px':'125px'}">
      <div class="addressPart">
        <div class="address_div">
            <span>收货地址</span>
            <button class="ben_btn" @click="addNewAddr()" v-if="addressChange==2">新增</button>
        </div>
        <div class="scroll" v-if="AddressList.length > 0 && addressChange==2">
          <div @click.stop.prevent="PushItemDetail(item,index)"
            :class="['AddressItem',item.is_default === 1 ? 'default':'']" v-for="(item,index) in AddressList"
            :key="item.id">
            <div :class="['item', activeIndex === index ? 'active':'']">
              <p class="name">{{item.name}}</p>
              <p class="phone">{{item.phone}}</p>
              <p class="addre">{{item.province + ' ' +item.city + ' '+ item.area}}</p>
              <p class="detail detail-ellipsis">{{item.address}}</p>
              <div class="bottomBtn">
                <div class="btn" @click.stop.prevent="delAddr(item.id, index)">删除</div>
                <div :class="['btn',item.is_default === 1?'noblock':'']" @click.stop.prevent="setAddr(item)">修改</div>
                <div v-if="item.is_default !== 1" class="btn2" @click.stop.prevent="setDefault(item.id)">设为默认地址</div>
                <div v-if="item.is_default === 1" class="btn2"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="scroll" v-if="zxAddressList.length > 0 && addressChange==1">
          <div @click.stop.prevent="PushZXItemDetail(item,index)" class="AddressItem" v-for="(item,index) in zxAddressList" :key="item.id">
            <div :class="['item', zxActiveIndex === index ? 'active':'']">
              <p class="name">{{item.name}}</p>
              <p class="phone">{{item.phone}}</p>
              <p class="addre">{{item.province + ' ' +item.city + ' '+ item.area}}</p>
              <p class="detail detail-ellipsis">{{item.address}}</p>
              <p class="opening_hours ">营业时间 {{item.shop_hours}}</p>
              <div class="bottomBtn">
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="addNew" @click="addNewAddr()">+ 新增收货地址</div> -->
        <div class="address_change">
          <van-row type="flex">
            <van-col span="6"><button class="ben_btn address_btn" :class="addressChange==2?'select_btn':''" @click="addressDivChange(2)">收货地址</button></van-col>
            <van-col span="6"><button class="ben_btn ziti_btn" :class="addressChange==1?'select_btn':''" @click="addressDivChange(1)">自提</button></van-col>
          </van-row>
        </div>
      </div>
      <div class="goodsPart">
        <div class="eachItem" v-for="(item,index) in itemList" :key="item.supplier_id">
          <div class="top">
            <p class="name">{{item.company_name}}</p>
            <div class="rowList" v-for="(ite) in item.goodsDetailList" :key="ite.id">
              <img :src="ite.coverimg" alt="" class="itemImg">
              <div class="itemDetail">
                <div class="leftPart">
                  <p class="itemName">{{ite.product_name}}</p>
                  <div class="specs">
                    <p>{{ite.spec_details}}</p>
                  </div>
                </div>
                <div class="rightPart">
                  <p class="price">￥{{ite.unit_prices}}</p>
                  <p class="numb">X{{ite.number}}</p>
                </div>
              </div>
            </div>
            <div class="line">
              <p class="tex">运送方式</p><span class="texdetail">{{addressChange==2?"普通配送":"自提"}}</span>
            </div>
            <div class="line">
              <p class="tex">给供应商留言</p>
              <textarea class="message" placeholder="选填，200字内" :ref="'leaveWord'+index" @input="listen(index)"
                @focus="changeStyle(1)" @blur="changeStyle(2)" :style="{height: textHeight}"
                v-model="leaveMsg[index]"></textarea>

            </div>

          </div>
        </div>
        <div class="fee_div">
          <div class="free_title">价格明细</div>
          <div class="free_ul">
            <div class="free_li">
              <p class="free_li_l">商品总价<span>共{{itemList[0].goodsDetailList.length}}件商品</span></p>
              <p class="free_li_r">￥<strong>{{FenToYuan(parseInt(noFeeTotalAmount)*100+parseInt(discounts)*100)}}</strong></p>
            </div>
            <div class="free_li">
              <p class="free_li_l">邮费</p>
              <p class="free_li_r">￥<strong>{{addressChange==2?(contFee/100).toFixed(2):0}}</strong><span></span></p>
            </div>
            <div class="free_li free_li_t">
              <p class="free_li_l">活动优惠</p>
              <p class="free_li_r">减￥<strong>{{discounts}}</strong></p>
            </div>
            <div class="free_li">
              <p class="free_li_l">合计</p>
              <p class="free_li_r">￥<strong>{{(addressChange==2 )?totalAmount:noFeeTotalAmount}}</strong></p>
            </div>
          </div>
        </div>
        <!-- <div class="read read_top">
          <van-row>
            <van-col span="8"> <p class="agree"><i :class="['check',checkFlagNum?'checked':'']"
              @click.stop.prevent="checkFlagNum = !checkFlagNum"></i>优惠码
              </p></van-col>
            <van-col span="12" class="agree_top"><van-field v-model="digitNum" :disabled ="!checkFlagNum" type="digit" maxlength="6" :placeholder='checkFlagNum?"请输入优惠号":""'/> </van-col>
          </van-row>
        </div> -->

      </div>
    </div>
    <div class="bottomCheck" :style="{bottom: tabHeight+'px'}" v-show="bottomCheckShow">
      <div class="read">
          <p class="agree"><i :class="['check',checkFlag?'checked':'']"
              @click.stop.prevent="checkFlag = !checkFlag"></i>我已阅读并同意<span class="contract"
              @click.stop.prevent="checkContract()">《商城交易合同》</span></p>
        </div>
      <div class="hall">
        <div class="hall_left">
          <div class="hall_left_div">合计: <span>￥<strong>{{(addressChange==2 )?totalAmount:noFeeTotalAmount}}</strong></span></div>
          <div class="hall_left_div">共{{total}}件</div>
            <!-- ,已省<span class="ben_red">￥1000</span></div> -->
        </div>
        <div class="hall_right">
          <span :class="['btn', ifSubmitFun() ? 'disable':'']" @click="!checkFlag?alertRead():submit()">提交订单</span>
        </div>
      </div>
    </div>
    <mt-popup v-model="show" :closeOnClickModal="0" position="bottom" class="pay-popup"
      :style="{paddingBottom:tabHeight+'px'}">
      <div class="header" @click="cancelClick">
        <div class="close"></div>
        <div class="tip">{{title}}</div>
      </div>
      <div class="pay-money pay-money4">
        <div class="money">
          ￥{{(addressChange==2)?totalAmount:noFeeTotalAmount}}
        </div>
      </div>
      <div class="pay-type" :style="{marginBottom: tabHeight+'px'}">
        <div v-if="!iswx">
          <div class="pay-box" v-for="(value, index) in items" :key="value.id"
            @click="selPayTypeClick(1,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
        <div v-if="iswx">
          <div class="pay-box" v-for="(value, index) in items2" :key="value.id"
            @click="selPayTypeClick(2,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="apply" @click="surePayClick" :style="{backgroundColor:activeStyle}">确认支付</div>
      </div>
      <!-- H5支付form表单 -->
      <div v-html="htmlForm"></div>
    </mt-popup>
    <pdfView v-show="pdfShow" @hidePdf='ShowPdf' :PdfUrl='pdfUrl'></pdfView>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
import { Dialog } from 'vant'
import calcTextareaHeight from './calcHeight'
import wxshare from '../../../wx/weixin'
import pdfView from '../../../components/pdfView'
export default {
  inject: ['reload'],
  components: {
    pdfView
  },
  computed: {
    ...mapState({
      commodity: 'commodity',
      reloadOrderId: 'MallOrderId'
    }),
    isActive () {
      if (this.payIndex > 0 && this.getOrderIdFlag) {
        return true
      }
      return false
    }

  },
  watch: {

    isActive: function (val) {
      if (val === true) {
        this.activeStyle = '#C41335'
      } else {
        this.activeStyle = '#FECDCD'
      }
    }

  },
  data () {
    return {
      itemList: [],
      getOrderIdFlag: false,
      tabHeight: '0',
      timerState: '',
      leaveMsg: ['', ''],
      title: '支付金额',
      textHeight: 18 + 'px',
      activeIndex: 0,
      activeAddr: {},
      zxActiveIndex: 0,
      zxActiveAddr: {},
      AddressList: [],
      zxAddressList: [],

      origin: [],
      total: 0,
      totalAmount: 0, //
      noFeeTotalAmount: 0,
      // message: [''],
      show: false,
      items: [
        { id: '1', title: '支付宝支付', image: require('../../../assets/icon_pay_alipay.png'), isSel: 0 },
        { id: '2', title: '微信支付', image: require('../../../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../../../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      items2: [
        // { id: '1', title: '支付宝支付', image: require('../../../assets/icon_pay_alipay.png'), isSel: 0 },
        { id: '2', title: '微信支付', image: require('../../../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../../../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      payType: '',
      payIndex: 0,
      payInfo: {
        id: ''
      },
      msgImg_n: require('../../../assets/radio_n.png'),
      msgImg_s: require('../../../assets/radio_s.png'),
      activeStyle: '#FECDCD',
      htmlForm: '',
      iswx: false,
      timmer: '',
      checkFlag: false,
      pdfUrl: '',
      pdfShow: false,
      fee: 0,
      contFee: 0, // 运费
      addressChange: 2, // 1:自提 2 :快递
      noFeeAmount: 0,
      bottomCheckShow: true, // 底部按钮显示与隐藏
      appquery: this.$router.history.current.query.isApp,
      isApp: 0,
      discounts: 0, // 优惠价格
      couponId: null // 优惠券ID
    }
  },
  methods: {
    ifSubmitFun () {
      let submitBtn = false
      if (this.checkFlag) {
        submitBtn = true
      } else if (!this.checkFlag) {
        submitBtn = false
      }
      return !submitBtn
    },
    addressDivChange (num) {
      this.addressChange = num
    },
    changeStyle (type) {
      let that = this

      if (type === 1) {
        that.tabHeight = 0
      } else {
        that.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    },
    alertRead () {
      Toast('请先阅读商城交易合同')
    },
    ShowPdf (data) {
      this.pdfShow = data
    },
    checkContract () {
      console.log('点击')
      this.pdfUrl = 'http://cdn.zxzx119.com/cght.pdf?attname=销售合同.pdf'
      this.pdfShow = true
    },
    listen (i) {
      this.textHeight = calcTextareaHeight(this.$refs.textarea[i], 1, null).height
      console.log(this.textHeight)
    },
    checkPayParam () {
      if (this.payIndex <= 0) {
        Toast('请选择支付方式！')
        return false
      }
      return true
    },
    getMailObj () {
      let leaveWordList = []
      let cartIds = ''
      let cartIdArr = []
      let cont = 0
      let goodsList = []
      this.itemList.forEach((item, index) => {
        // cont += parseInt(item.sendAmount)
        item.goodsDetailList.forEach((ite, ind) => {
          goodsList.push(ite)
          cartIdArr.push(ite.tails.cartId)
        })
        leaveWordList.push({
          leave_word: this.leaveMsg[index],
          supplier_id: item.supplier_id
        })
      })
      cartIds = cartIdArr.join(',')
      let tails = {}
      let obj = {}
      let selectAddr = {}//
      if (this.addressChange == 1) { // 自提
        selectAddr = this.zxActiveAddr
      } else if (this.addressChange == 2) { // 快递
        selectAddr = this.activeAddr
      }
      tails = {
        area: selectAddr.area,
        city: selectAddr.city,
        detail_address: selectAddr.address,
        freight: parseInt(this.contFee),
        province: selectAddr.province,
        province_city_area: selectAddr.province + selectAddr.city + selectAddr.area,
        receiver: selectAddr.name
      }
      obj = {
        cartIds: cartIds,
        goodsDetailList: goodsList,
        is_contains_eval: 0,
        leaveWordList: leaveWordList,
        delivery_method: this.addressChange, // 1 :自提 2 : 快递
        discount_number: parseInt(this.discounts) * 100,
        is_package: '0'
      }
      if (this.addressChange == 1) { // 自提
        obj['user_phone'] = this.zxActiveAddr.phone
        obj['amount'] = this.noFeeTotalAmount * 100
        obj['custom_shop_id'] = this.zxAddressList[this.zxActiveIndex]['id']
        obj['delivery_status'] = 0 // 0 : 未提货 1: 已提货
      } else if (this.addressChange == 2) { // 快递
        obj['amount'] = this.totalAmount * 100
        obj['user_phone'] = this.activeAddr.phone
        obj['tails'] = tails
      }
      if (this.couponId) {
        obj['coupon_id'] = this.couponId
      }
      return obj
    },
    getOrderId () {
      let _this = this
      if (this.reloadOrderId === '') {
        let obj = _this.getMailObj()
        _this.utils.post(this.companyUrl + '/zxOrder/newMallOrder', obj, res => {
          this.$store.commit('storeOrderId', res.data.id)
          this.$store.commit('setIsNewMallOrder', true)
          this.getOrderIdFlag = true
          try {
            if (_this.isApp && _this.isApp === 2) {
              if (_this.utils.isIphone()) { // ios 支付
                window.webkit.messageHandlers.orderSuccess.postMessage(null)
              } else {
                window.zxzx.orderSuccess()
              }
            }
          } catch (error) {
            console.log('orderSuccess 报错')
          }
        })
      }
    },
    surePayClick () {
      let _this = this
      if (this.isActive) {
        if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1) {
          // 消防云 中消商城  支付宝 微信支付  下单 支付
          // app 内嵌网页掉支付
          let enterType = localStorage.getItem('enterType')
          if (enterType === undefined || enterType === null) {
            enterType = 0
          } else {
          }
          console.log('enterType:', enterType, this.payIndex)
          if (enterType === 1) { // app 内嵌网页掉支付
            if (this.payIndex === 3) { // 线下 审核汇款
              console.log('===================线下汇款')
              this.$router.push({ path: '/remittance', query: { orderID: this.reloadOrderId } })
            } else {
              if (this.utils.isIphone()) { // ios 支付
                console.log('iOS -- app内嵌h5支付')
                window.webkit.messageHandlers.startPay.postMessage({
                  'payType': this.payType,
                  'orderId': this.reloadOrderId
                })
              } else {
                console.log('Android -- app内嵌h5支付')
                window.zxzx.startPay(this.payType, this.reloadOrderId)
              }
              // 查询支付状态
              this.payState()
            }
            return
          }
          return
        }

        if (this.utils.isWX()) {
          if (this.payType === 'wx_jsapi') {
            if (localStorage.getItem('openId') !== null) {// 已经授权过有了openid
                this.toPay(this.reloadOrderId, localStorage.getItem('openId'))
                return false;
              } else {//去授权
                let redirectURI = encodeURIComponent(window.location.href)
                  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appIdMall +
                  '&redirect_uri=' + redirectURI +
                  '&response_type=code&scope=snsapi_base&state=WXPaySTATE&connect_redirect=1#wechat_redirect'
              }
          }
        }

        if (this.payIndex === 3) {
          this.$router.push({ path: '/remittance', query: { orderID: this.reloadOrderId } })
        } else {
          this.utils.post(this.companyUrl + '/newPay/' + this.payType + '/' + this.reloadOrderId, null, res => {
            let payUrl = res.data.payUrl
            if (payUrl.indexOf('http') === 0) { // 微信
              window.location.href = payUrl
            } else { // 支付宝
              this.htmlForm = payUrl
              setTimeout(function () {
                document.forms[0].submit()
              }, 500)
            }
          })
        }
        this.getOrderIdFlag = false
      }
    },
    // let
    payState () {
      // 查询支付状态
      this.utils.POST(this.companyUrl + '/pay/status/' + this.reloadOrderId, null, response => {
        if (response.data.pay_state === '未付款') {
          this.timerState = setTimeout(function () {
            this.payState()
          }, 5000)
        } else {
          clearTimeout(this.timerState)
          Toast('支付成功了！')
          this.$router.replace({
            path: '/orderListDetail',
            query: {
              orderId: this.reloadOrderId
            }
          })
        }
      })
    },
    cancelClick () {
      if (this.itemList[0]['isNewMallOrder']) {
        this.$router.replace({
          path: '/orderListDetail',
          query: {
            orderId: this.reloadOrderId
          }
        })
      } else {
        this.show = false
      }
    },
    selPayTypeClick (index, value, id) {
      this.getOrderId()
      this.payIndex = parseInt(id)
      switch (this.payIndex) {
        case 1:
          // this.payType = 'alipay_pc_direct'
          this.payType = 'alipay_wap'
          break
        case 2:
          if (this.utils.isWX()) {
            this.payType = 'wx_jsapi'
          } else {
            this.payType = 'wx_wap'
          }
          break
        case 3:
          this.payType = 'remittance'
          break
      }
      if (index === 1) {
        this.items.forEach((item, index) => {
          item.isSel = 0
        })
      } else {
        this.items2.forEach((item, index) => {
          item.isSel = 0
        })
      }
      value.isSel = 1
    },
    forId (index) {
      return 'selectImg' + index
    },
    back () {
      this.$router.back(-1)
    },
    addNewAddr () {
      this.$router.push({
        path: '/editAddress',
        query: {
          editAddressType: 0
        }
      })
    },
    setAddr (item) {
      this.$router.push({
        path: '/editAddress',
        query: {
          editAddressType: 1,
          editAddressBean: item
        }
      })
    },
    PushItemDetail (item, index) {
      this.activeIndex = index
      this.activeAddr = item
      this.getFee()
      // this.$store.commit('setCommodity', JSON.stringify(this.AddressList))
    },
    PushZXItemDetail (item, index) {
      this.zxActiveIndex = index
      this.zxActiveAddr = item
    },
    setDefault (id) {
      let obj = {
        id: id
      }
      this.utils.POST(this.accountUrl + '/site/default/set',
        obj,
        resj => {
          Toast('设置成功！')
          // EventBus.$emit('add_changeed')
          this.getAddressList()
          this.activeIndex = 0
        }
      )
    },
    delAddr (id, index) {
      Dialog.confirm({
        title: '提示',
        message: '是否删除此条地址?'
      }).then(() => {
        let obj = {
          id: id
        }
        this.utils.POST(
          this.accountUrl + '/site/delete',
          obj,
          resj => {
            Toast('删除成功！')
            // EventBus.$emit('add_changeed')
            this.getAddressList()
            // this.activeIndex = index
          }
        )
      })
    },
    getFee () {
      let weightTotal = 0
      let feeResult = 0
      let total = 0
      let goodsId = []
      let obj = {
        province: this.activeAddr ? this.activeAddr.province : '',
        city: this.activeAddr ? this.activeAddr.city : ''
      }
      this.itemList.forEach((item, index) => {
        item.goodsDetailList.forEach((ite, ind) => {
          goodsId.push(ite.goods_id)
          weightTotal += ite.goods_weight * ite.number
        })
        total += parseInt(item.sendAmount)
      })
      this.totalAmount = this.FenToYuan(total)
      this.noFeeTotalAmount = this.FenToYuan(total)
      obj['weight'] = weightTotal
      let paroms = this.getMailObj()
      this.utils.post(this.companyUrl + '/freightTemplate/getFreight', paroms, res => {
        this.contFee = parseInt(res.data.fee)
        feeResult = parseInt(res.data.fee)
        this.itemList.forEach((item, index) => {
          item.amount = ((parseInt(item.sendAmount) + feeResult) / 100).toFixed(2)
          item.nofeeDmount = ((parseInt(item.sendAmount)) / 100).toFixed(2)
        })
        this.totalAmount = this.FenToYuan(total + feeResult) // 有运费的总价
        this.noFeeTotalAmount = this.FenToYuan(total) // 没有运费的总价
        this.fee = this.FenToYuan(feeResult)
        this.getCouponList(goodsId.join(','))// 查询优惠活动
      })
    },
    getCouponList (goodsId) {
      this.utils.get(this.companyUrl + '/coupon/getMyCouponList?goodsId=' + goodsId, null, res => {
        console.log(res)
        if (res.data.length < 1) {
          return false
        }
        let couponList = res.data[0]
        let couponGoodsDeta = false
        this.itemList.forEach((item, index) => {
          couponGoodsDeta = item.goodsDetailList.find((ite) => {
            ite.goods_id = couponList.goods_id
            return ite.goods_id
          })
        })
        if (couponGoodsDeta) {
          /// / 0 原价 1 折扣价
          let goodsPrice = couponGoodsDeta.price_type == 0 ? couponGoodsDeta.number * parseInt(couponGoodsDeta.original_price) : couponGoodsDeta.number * parseInt(couponGoodsDeta.unit_price)
          if (goodsPrice >= parseInt(couponList.with_amount)) { // 减去优惠券价格
            console.log(parseInt(this.totalAmount), parseInt(couponList.used_amount) / 100, couponList.used_amount)
            this.totalAmount = this.FenToYuan(parseInt(this.totalAmount) * 100 - (parseInt(couponList.used_amount))) // 有运费的总价
            this.noFeeTotalAmount = this.FenToYuan(parseInt(this.noFeeTotalAmount) * 100 - (parseInt(couponList.used_amount))) // 没有运费的总价
            this.discounts = (parseInt(couponList.used_amount) / 100).toFixed(2)// 优惠价格
            this.couponId = couponList.couponUserList[0].id // 优惠券ID
          }
        }
        console.log(couponGoodsDeta)
      })
    },
    getAddressList () {
      this.AddressList = []
      this.utils.get(this.accountUrl + '/site/list', null, res => {
        this.AddressList = res.data
        this.activeAddr = this.AddressList[this.activeIndex]
        this.getFee()
      })
    },
    getZXAddressList () {
      this.zxAddressList = []
      this.utils.get(this.companyUrl + '/customStore/findByParam', {
        province: '',
        city: '',
        area: '',
        page: 1,
        pageSize: 100
      }, res => {
        this.zxAddressList = res.data.rows
      })
    },

    submit () {
      if ((JSON.stringify(this.activeAddr) === '{}' || this.activeAddr === undefined) && this.addressChange == 2) {
        Toast('请先选择收货地址')
      } else {
        this.show = true
      }
    },
    WX () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    toDecimal2 (x) {
      var f = parseFloat(x)
      if (isNaN(f)) {
        return false
      }
      var E = Math.round(x * 100) / 100
      var s = E.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s
    },

    FenToYuan (data) {
      let num = data
      num = data * 0.01
      num += ''
      let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
      num = num.replace(reg, '$1')
      num = this.toDecimal2(num)
      return num
    },

    getopenId (code) {
      this.utils.post(this.companyUrl + '/newPay/getOpenId?code=' + code, null, res => {
        if (res.code === 0) {
          localStorage.setItem('openId', res.data)
          this.toPay(this.reloadOrderId, res.data)
        }
      })
    },
    onBridgeReady (data) {
      let param = data.payParams
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          'appId': param.appId, // 公众号名称，由商户传入
          'timeStamp': param.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': param.nonceStr, // 随机串
          'package': param.package,
          'signType': param.signType, // 微信签名方式：
          'paySign': param.paySign // 微信签名
        },
        res => {
          this.$store.commit('clearOrderId', '')
          this.$router.replace({
            path: '/orderListCenter',
            query: {
              status: 0,
              tag: 1
            }
          })
        })
    },
    launchWXPay (data) { // 微信浏览器发起微信支付 wx_jsapi
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data))
        }
      } else {
        this.onBridgeReady(data)
      }
    },
    toPay (orderid, openId) {
      this.utils.post(this.companyUrl + '/newPay/wx_jsapi/' + orderid + '?openId=' + openId, null, res => {
        console.log(res)
        if (res.code === 0) {
          this.launchWXPay(res.data)
        }
      })
    },
    androidTabHeight (value) {
      // 设置android 模态导航条
      console.log('androidTabHeight:', value)
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 0
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = value !== 'null' ? parseInt(value) : 0
        console.log('this.tabHeight:', this.tabHeight)
      }
    },
    paySuccess (state) {
      if (state === '0') {
        // 支付成功，跳转至订单列表
        this.$store.commit('clearOrderId', '')
        this.$router.replace({
          path: '/orderListCenter',
          query: {
            status: 4,
            tag: 0
          }
        })
      }
    },
    keyboardState (style) { // 1:显示 2:隐藏
      if (style == 2) {
        this.bottomCheckShow = true
        this.itemList.forEach((item, index) => {
          console.log(`leaveWord${index}`)
          this.$refs['leaveWord' + index][0].blur()
        })
      } else if (style == 1) {
        this.bottomCheckShow = false
      }
    },

    oldMounted () {
      let _this = this
      window['paySuccess'] = (result) => {
        _this.paySuccess(result)
      }
      window['keyboardState'] = (result) => {
        _this.keyboardState(result)
      }
      wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
      this.iswx = this.WX()
      // console.log(this.itemList)
      this.itemList.forEach((item, index) => {
        if (!item.sendAmount) {
          item.sendAmount = parseInt(item.amount)
        }
        item['message'] = ''
        this.total += parseInt(item.goodsDetailList.length)
        item.goodsDetailList.forEach((ite, ind) => {
          if (!ite.spec_details) {
            let spec = JSON.parse(ite.spec_detail)
            ite.spec_details = '规格：' + spec['规格'] + ' ' + '颜色：' + spec['颜色']
          }
          if (!ite.unit_prices) {
            ite.unit_prices = this.FenToYuan(parseInt(ite.unit_price))
          }
          ite.coverimg = ite.product_cover.split(',')[0]
        })
      })
      if (this.utils.isWX()) {
        if (this.$route.query.code !== undefined && localStorage.getItem('openId') === null) {
          // 首次授权重定向
          this.getopenId(this.$route.query.code)
        } else if (localStorage.getItem('openId') === null) {
          let redirectURI = encodeURIComponent(window.location.href)
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appIdMall +
              '&redirect_uri=' + redirectURI +
              '&response_type=code&scope=snsapi_base&state=WXPaySTATE&connect_redirect=1#wechat_redirect'
        }
        // else if (localStorage.getItem('openId') !== null) {
        //   // 授权后再次进入 or 授权后首次进入
        //   let opId = localStorage.getItem('openId')
        //   if (this.reloadOrderId !== '') {
        //     this.toPay(this.reloadOrderId, opId)
        //   }
        // }
      }
    }
  },

  created () {
    if (this.$route.query.isApp) {
      this.isApp = parseInt(this.$route.query.isApp)
      localStorage.setItem('isApp', this.isApp)
      if (this.isApp === 2) {
        this.utils.GET(this.companyUrl + '/ent/json',
          function (res) {
            localStorage.setItem('userinfo', JSON.stringify(res.data))
          })
      }
    } else if (localStorage.getItem('isApp')) {
      this.isApp = parseInt(localStorage.getItem('isApp'))
    }
    if (!this.$route.query.cartGoodIds) {
      this.itemList = this.commodity
    }
    if (this.itemList && this.itemList[0] && this.itemList[0]['isNewMallOrder']) {
      this.$router.replace({
        path: '/orderListDetail',
        query: {
          orderId: this.reloadOrderId
        }
      })
    }
    var _this = this
    if (!this.$route.query.cartGoodIds) {
      _this.getAddressList()
      _this.getZXAddressList()
      _this.oldMounted()
    } else {
      this.utils.GET(this.companyUrl + '/shoppingCart/getCartGoodsList?ids=' + this.$route.query.cartGoodIds, function (response) {
        let orderDetail = response.data
        orderDetail.forEach((val, index) => {
          orderDetail[index]['isNewMallOrder'] = false// 是否生成订单
        })
        var jsonStr = JSON.stringify(orderDetail)
        _this.$store.commit('setCommodity', jsonStr)
        _this.$store.commit('clearOrderId', '')
        _this.itemList = orderDetail
        _this.getAddressList()
        _this.getZXAddressList()
        _this.oldMounted()
      })
    }
  },
  mounted () {
    if (this.$route.query.isApp) {
      localStorage.setItem('isApp', this.$route.query.isApp)
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 ||
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      window['androidTabHeight'] = (result) => {
        this.androidTabHeight(result)
      }
      console.log('进来确认订单页面：this.utils.isIphone()', this.utils.isIphone(), window.zxzx.getNavigationBarHeight())
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
        console.log('window.zxzx.getNavigationBarHeight():', window.zxzx.getNavigationBarHeight())
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/goodsdetail' || to.path === '/orderListDetail' || to.path === '/shoppingCart') {
      this.$store.commit('clearOrderId', '')
      next()
      // }
    } else {
      next()
    }
  }
  // ,
  // beforeRouteEnter (to, from, next) {
  //   Toast('-===========进入页面')
  // }
}
</script>

<style lang="scss" scoped>
div {
  user-select: text;
  height: auto;
}
div * {
  user-select: text;
}

#checkOrder {
  width: 100%;
  min-height: 100vh;
  // height: 100vh;
  background: #f4f4f4;
  .ben_btn{
    height: 30px;
    line-height: 28px;
    text-align: center;
    color: #C41335;
    border: 1px solid #C41335;
    border-radius: 5px;
    font-size: 12px;
  }
  .address_change{
    padding:0 10px;

  .ziti_btn,.address_btn{
    background: #fff;
    width: 70px;
    color: #C41335;
  }
  .select_btn{
    background: #C41335;
    color: #ffffff;
  }
  }
  .title {
    height: 50px;
    line-height: 50px;
    padding: 0 16.5px 0 14px;
    background: #ffffff;
    margin-bottom: 10px;
    .name {
      font-size: 15px;
      color: #000000;
      font-weight: bold;
      .back {
        float: right;
        font-size: 13px;
        color: #999999;
        .backIcon {
          display: inline-block;
          vertical-align: top;
          margin-left: 5px;
          font-size: 13px;
          color: #999999;
          font-style: inherit;
        }
      }
    }
  }
  .MainBody {
    padding: 0 15px 86px 15px;
    .addressPart {
      position: relative;
      background: #ffffff;
      width: 100%;
      min-height: 60px;
      border-radius: 4px 4px 4px 4px;
      padding: 13px 0 13px 0;
      overflow: hidden;
      margin-bottom: 10px;
      .address_div{
        padding: 0 10px;
        height: 40px;
        span{
          font-size: 14px;
          font-weight: bold;
          color: #000000;
        }
        >button{
          width: 45px;
          background: #C41335;
          color: #ffffff;
          float: right;
        }
      }
      .scroll {
        width: 100%;
        // height: 156px;
        padding: 0px 10px 0 10px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        display: inline-block;
        margin-bottom: 15px;
        .AddressItem {
          position: relative;
          width: 185px;
          height: 156px;
          border-radius: 4px;
          background: #f9f9f9;
          display: inline-block;
          margin-right: 8px;
          vertical-align: top;
          .item {
            display: inline-block;
            width: 183px;
            height: 154px;
            .name {
              width: 100%;
              height: 32.5px;
              line-height: 32.5px;
              text-align: left;
              color: #000000;
              font-size: 12px;
              font-weight: bold;
              padding-left: 10.5px;
              border-bottom: 0.01rem solid #eeeeee;
              margin-bottom: 10px;
            }
            .phone {
              width: 100%;
              line-height: 12px;
              font-size: 12px;
              color: #333333;
              text-align: left;
              padding-left: 10.5px;
              margin-bottom: 5px;
            }
            .addre {
              width: 100%;
              padding: 0 10.5px 0 10.5px;
              font-size: 12px;
              color: #333333;
              line-height: 12px;
              margin-bottom: 3px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .detail {
              width: 100%;
              padding: 0 10.5px 0 10.5px;
              font-size: 12px;
              color: #333333;
              line-height: 17px;
              white-space: pre-wrap;
            }
            .opening_hours{
              font-size: 12px;
              color: #808080;
               padding-left: 10.5px;
               margin-top: 5px;
            }
            .detail-ellipsis{
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .bottomBtn {
              position: absolute;
              bottom: 13px;
              left: 0;
              width: 100%;
              display: flex;
              .btn {
                color: #c41335;
                font-size: 12px;
                position: relative;
                flex: 1;
                text-align: center;
              }
              .btn::after {
                content: "";
                position: absolute;
                width: 2px;
                top: 2px;
                right: 0;
                height: 14px;
                background: #cccccc;
              }
              .noblock::after {
                content: "";
                display: none;
              }
              .btn2 {
                color: #c41335;
                font-size: 12px;
                flex: 2;
                text-align: center;
              }
            }
          }
        }
        .AddressItem:last-child {
          margin-right: 0;
        }
        .active::before {
          content: "";
          position: absolute;
          width: 185px;
          height: 156px;
          top: 0;
          left: 0;
          border: 1px solid #c41335;
          border-radius: 4px;
        }
        .default::before {
          content: "默认地址";
          position: absolute;
          top: 0px;
          right: 0px;
          width: 56px;
          height: 19px;
          line-height: 19px;
          background: #cccccc;
          border-radius: 0 4px 0 4px;
          text-align: center;
          color: #ffffff;
          font-size: 0.24rem;
        }
        .active::after {
          content: "";
          position: absolute;
          bottom: -2px;
          right: -3px;
          width: 17px;
          height: 17px;
          background: url("../images/defaultChoose.svg") no-repeat center center;
          background-size: contain;
          border-radius: 4px 0 4px 0;
        }
      }
      .scroll::-webkit-scrollbar {
        display: none;
      }
      .addNew {
        // position: absolute;
        width: 104px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border: 1px solid #fecdcd;
        border-radius: 2px;
        font-size: 12px;
        color: #c41335;
        margin-left: 10.5px;
        bottom: 20px;
      }
    }
    .goodsPart {
      position: relative;
      display: inline-block;
      width: 100%;
      .eachItem {
        width: 100%;
        background: #ffffff;
        font-size: 0;
        border-radius: 4px;
        margin-bottom: 10px;
        .top {
          border-radius: 4px 4px 0 0;
          padding: 23px 10px 20px 10px;
          border-bottom: 1px solid #eeeeee;
          .name {
            display: inline-block;
            font-size: 14px;
            color: #0e050a;
            font-weight: bold;
            line-height: 14px;
            width: 193px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 23px;
          }
          .rowList {
            display: inline-block;
            width: 100%;
            margin-bottom: 30px;
            .itemImg {
              display: inline-block;
              width: 90px;
              height: 90px;
              border: 0.01rem solid #eeeeee;
              vertical-align: top;
              margin-right: 10px;
            }
            .itemDetail {
              width: calc(100% - 100px);
              // width: 100%;
              display: inline-block;
              .leftPart {
                display: inline-block;
                width: 57%;
                .itemName {
                  // width: 146px;
                  font-size: 13px;
                  line-height: 17px;
                  color: #0e050a;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  margin-bottom: 5px;
                }
                .specs {
                  display: inline-block;
                  background: #eeeeee;
                  padding: 6px 8px 0px 10px;
                  font-size: 12px;
                  color: #808080;
                  p {
                    margin-bottom: 7px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                }
              }
              .rightPart {
                float: right;
                text-align: right;
                .price {
                  font-size: 13px;
                  color: #000000;
                }
                .numb {
                  font-size: 13px;
                  color: #bebebe;
                }
              }
            }
          }
          .rowList:last-child {
            margin-bottom: 0;
          }
          .line {
            display: inline-block;
            width: 100%;
            background: #ffffff;
            // white-space: pre-line;
            margin-bottom: 20px;
            .tex {
              font-size: 12px;
              color: #000000;
              display: inline-block;
              width: 97px;
              vertical-align: top;
            }
            .texdetail {
              font-size: 12px;
              color: #000000;
              display: inline-block;
              width: calc(100% - 100px);
            }
            .message {
              display: inline-block;
              width: calc(100% - 100px);
              // line-height: 14px;
              border: none;
              outline: none;
              font-size: 12px;
              color: #000000;
            }
          }
          .line:last-child {
            margin-bottom: 0;
          }
        }
        .bottom {
          padding: 0 10px 0 10px;
          line-height: 40px;
          height: 40px;
          //           <p class="total">共{{item.goodsDetailList.length}}件
          //   <span class="text"> 店铺合计：<font>{{item.amount}}</font>
          //   </span>
          // </p>
          .total {
            display: inline-block;
            width: 100%;
            color: #808080;
            font-size: 12px;
            text-align: right;
            .text {
              color: #000000;
              font-size: 12px;
              font {
                font-weight: bold;
                color: #c41335;
                font-size: 12px;
              }
            }
          }
        }
      }
      .fee_div{
        background-color: #fff;
        border-radius: 4px;
        padding: 10px 10px 1px 10px;
        color: #000000;
        .free_title{
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .free_li{
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 12px;
        }
        .free_li_t{
          .free_li_l{
            background: url("../../../assets/youhui_img.png") no-repeat;
            background-size: 15px;
            padding-left: 20px;
            background-position: 0px 1px;
          }
          .free_li_r{
            color: #C41335;
          }
        }
        .free_li_l{
          span{
            font-size: 12px;
            color: #808080;
            padding-left: 5px;
          }
        }
        .free_li_r{
          strong{
            font-size: 14px;
          }
          span{
            font-size: 12px;
          }
        }
      }
      // .eachItem:last-child {
      //   margin-bottom: 0;
      // }
      //       <div class="read">
      //   <p class="agree"><i :class="['check',checkFlag?'checked':'']"
      //       @click.stop.prevent="checkFlag = !checkFlag"></i>我已阅读并同意<span class="contract"
      //       @click.stop.prevent="checkContract()">《商城交易合同》</span></p>
      // </div>
      .read_top{
        overflow: hidden;
        border-bottom: 1px solid #EEEEEE;
      }

    }
  }
  //   <div class="bottomCheck">
  //   <p class="hall">共{{total}}件
  //     <span class="conter">实付款：
  //       <font>￥{{totalAmount}}</font>
  //     </span>
  //   </p>
  // </div>
  .bottomCheck {
    position: fixed;
    bottom: 0;
    height: 105px;
    width: 100%;
    background: #ffffff;
    // padding: 0 15px 0 15px;
    font-size: 0;
    .read {
        position: relative;
        width: 100%;
        background: #ffffff;
        font-size: 0;
        height: 40px;
        border-radius: 4px;
        border-bottom: 1px solid #EEEEEE;
        .agree_top{
          border-left: 1px solid #EEEEEE;
        }
        .agree {
          line-height: 40px;
          font-size: 12px;
          color: #000000;
          // padding: 0 0px 0 20px;
          .check {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 40px;
            vertical-align: top;
            &::before {
              position: absolute;
              content: "";
              width: 12px;
              height: 12px;
              border: 1px solid #808080;
              border-radius: 50%;
              left: calc(50% - 6px);
              top: calc(50% - 6px);
            }
            &.checked::before {
              position: absolute;
              content: "";
              width: 12px;
              height: 12px;
              border: 1px solid #c41335;
              border-radius: 50%;
              left: calc(50% - 6px);
              top: calc(50% - 6px);
            }
            &.checked::after {
              content: "";
              position: absolute;
              width: 3px;
              height: 6px;
              left: calc(50% - 1px);
              top: calc(50% - 3px);
              border-color: #c41335;
              border-style: solid;
              border-width: 0 2px 2px 0;
              transform: rotate(45deg);
            }
          }

          .contract {
            cursor: pointer;
            margin-left: 5px;
            color: #c41335;
          }
        }
      }
    .hall {
      display: flex;
      width: 100%;
      font-size: 12px;
      color: #808080;
      // text-align: right;
      align-items: center;
      height: 65px;
      padding: 0 15px;
      .conter {
        font-size: 12px;
        color: #000000;
        margin-right: 10px;
        font {
          font-weight: bold;
          font-size: 15px;
          color: #c41335;
        }
      }
      .btn {
        display: inline-block;
        font-size: 15px;
        background: #c41335;
        border-radius: 4px;
        color: #ffffff;
        line-height: 15px;
        padding: 16px 18px 16px 18px;
      }
      .disable {
        background: #ee8b9f;
        cursor: not-allowed;
      }
    }
    .hall_left{
      width: 60%;
      .hall_left_div:first-child{
          color: #000000;
          font-size: 12px;
        span{
          color: #C41335;
          font-size: 12px;
          strong{
            font-size: 14px;
          }
        }
      }
      .hall_left_div:nth-child(2){
        span{
          color: #C41335;
        }
      }
    }
    .hall_right{
      width: 40%;
      text-align: right;
    }
  }
  .pay-popup {
    width: 100%;
    .header {
      position: relative;
      width: 100%;
      height: 45px;
      line-height: 45px;
      color: #000000;
      font-size: 17px;
      /*background-color: #C41335;*/
      border-bottom: solid #eeeeee 1px;
      box-sizing: border-box;
      .close {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 15px;
        height: 15px;
        padding: 5px;
        background-image: url("../../../assets/icon-pay-close.png");
        background-size: cover;
        background-position: center center;
      }
      .tip {
        position: absolute;
        left: 0px;
        right: 0px;
        text-align: center;
      }
    }
    .pay-money {
      position: relative;
      .money {
        position: relative;
        height: 60px;
        padding-top: 30px;
        line-height: 30px;
        font-size: 25px;
        font-weight: bold;
        color: #c41335;
        text-align: center;
      }
    }
    .pay-type {
      position: relative;
      width: 100%;
      /*top: 30px;*/
      padding-top: 10px;
      height: 190px;
      /*height: 130px;*/
      /*background-color: yellow;*/
      .pay-box {
        position: relative;
        width: 100%;
        height: 60px;
        line-height: 60px;
        /*background-color: #4BAE4F;*/
        .icon {
          position: absolute;
          top: 20px;
          left: 15px;
          width: 20px;
          height: 20px;
        }
        div {
          position: absolute;
          top: 0px;
          left: 50px;
          width: calc(100% - 60px);
          height: 60px;
          line-height: 60px;
          border-bottom: solid #eeeeee 1px;
          box-sizing: border-box;
        }
        .select {
          position: absolute;
          top: 20px;
          right: 15px;
          width: 20px;
          height: 20px;
        }
      }
    }
    .bottom {
      position: relative;
      width: 100%;
      bottom: 0px;
      height: 65px;
      line-height: 65px;
      background-color: #ffffff;
      /*border-top: solid #EEEEEE 1px;*/
      /*box-sizing: border-box;*/
      .apply {
        position: absolute;
        top: 10px;
        left: 15px;
        height: 45px;
        line-height: 45px;
        width: calc(100% - 30px);
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        background-color: #c41335;
        border-radius: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/shoppingCart/checkOrder.vue